export default{
  PAYMENT: "payment",
  HEALTH_SERVICE:"healthService",
  OTHER: "other"
}
